module.exports = __webpack_public_path__ + "static/media/0e150aac-2b24-42af-9185-e2cb0b6b773c.8d8647aa.JPG";